import React, {FC} from "react";
import './FeatureButtons.scss';
import {useStorageContext} from "@app/contexts/storage";
import {observer} from "mobx-react";

type TProps = {}
export const FeatureButtons: FC<TProps> = observer(function (props: TProps) {
    const {globalStorage} = useStorageContext();
    return <div className={"featureButtons"}>

        {globalStorage.functionsButton.map((Icon, index) => <Icon key={index}/>)}

    </div>
});
